module.exports = "mat-icon{\n\tfont-size: 18px;\n\tpadding: 2px;\n\theight: auto;\n\twidth: auto;\n}"